// import { ERROR_CODE_TO_SPECIAL_TEXT } from "@/constants";

export const handleErrors = (code, message, navigate) => {
  if ([200000, 200001].includes(code)) {
    navigate('../error?code=200000', { state: { code } });
    return;
  }
  // if (ERROR_CODE_TO_SPECIAL_TEXT.includes(code)) {
  navigate(`../error?code=${code}`, { state: { code, message } });
  // } else {
  //   navigate("/error");
  // }
};
